export default "__VITE_ASSET__KDlUv_lR__"